const url = window.location.pathname.split('/')[2];

if (url == '10-formations-courtes-pour-une-reconversion-rapide') {
  let elem = document.querySelector('.blog-styles > p > a');
  let frame = document.createElement('iframe');
  frame.setAttribute('src', elem);
  frame.setAttribute('width', 620);
  frame.setAttribute('height', 360);
  frame.setAttribute('allowFullScreen', '');
  frame.setAttribute('frameborder', 0);
  frame.setAttribute(
    'allow',
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
  );
  elem.parentNode.appendChild(frame);
  elem.parentNode.removeChild(elem);
}

//[https://www.youtube.com/embed/43sXT2GJRmI](https://www.youtube.com/embed/43sXT2GJRmI)
